import notificationAnalyticsTypes from "./notificationAnalyticsTypes";
import { PENDING, SUCCESS, ERROR } from "../../globalStatuses/globalStatuses";

const initialState = {
    status: '',
    data: null, // { branch_id, users: [] }
}

const notificationAnalyticsReducer = (state = initialState, action) => {
    switch (action.type) {
        case notificationAnalyticsTypes.GET_AUTO_NOTIFICATION_ANALYTICS_PENDING:
            return { ...state, status: PENDING }
        case notificationAnalyticsTypes.GET_AUTO_NOTIFICATION_ANALYTICS_SUCCESS:
            return { ...state, status: SUCCESS, data: action.payload }
        case notificationAnalyticsTypes.GET_AUTO_NOTIFICATION_ANALYTICS_ERROR:
            return { ...state, status: ERROR }
        default:
            return state
    }
}

export default notificationAnalyticsReducer;
